import { Flex } from '@chakra-ui/react';
import React from 'react';
import { convertPxToRems } from '~/utils-ts';

import { GroupedFilters } from '../hooks/useGroupFilters';
import { useAdvancedFiltersStore } from '../store/useAdvancedFilterStore';
import { useCreatorsFiltersStore } from '../store/useCreatorsFiltersStore';
import { AppliedCreatorFilters } from './AppliedCreatorFilters';
import { AdvancedFilterPill } from './TalentFilters/AdvancedFilterPill';

interface AppliedAdvancedFiltersProps {
  isShared: boolean;
  filters: GroupedFilters[];
  enabledControls: string[];
}

export function AppliedAdvancedFilters({
  isShared,
  filters,
  enabledControls,
}: AppliedAdvancedFiltersProps) {
  const { clearFilters } = useAdvancedFiltersStore();
  const { appliedFilters } = useCreatorsFiltersStore();

  if (filters.length === 0 && appliedFilters.length === 0) return null;

  return (
    <Flex
      marginY={convertPxToRems(16)}
      columnGap={convertPxToRems(4)}
      rowGap={convertPxToRems(8)}
      wrap="wrap"
    >
      {filters
        .filter(() => {
          // Decide whether or not to show the filters
          if (isShared) {
            // On shared page(s)
            return enabledControls?.includes('audience-filters') || false;
          }
          // Show all filters by default
          return true;
        })
        .map((filter: GroupedFilters) => {
          return (
            <AdvancedFilterPill
              filter={filter}
              clearFilters={clearFilters}
              key={`${filter.platform}-${filter.filterType}`}
            />
          );
        })}

      <AppliedCreatorFilters />
    </Flex>
  );
}
